<style lang="scss">
  @import "@/assets/scss/vuexy/pages/Detail.scss";

  .gauge > table{
    margin: auto!important;
  }

  .bg-light-info{
    background: #dbe8fc
  }
</style>
<template>
  <div>
    <div class="vx-row">
      <div class="w-full sm:w-auto  p-1">
        <vx-card class="p-4 pt-6 h-full flex items-center justify-center" v-if="response.percent">
          
              <GChart v-if="typeControl"
                :settings="{ packages: ['corechart', 'gauge'] }"
                type="Gauge"
                :data="data"
                :options="chartOptions"
                class="gauge"
              />
              <controlDigital v-else :nfc="true" :bluetooth="true" :value="parseInt(response.percent)"/>
              <div class="text-center mt-2">
                <img :src="getImgUrl('digital')" class="h-6 w-6 inline-block align-middle"/>
                <div class="inline-block align-middle mx-2">
                  <vs-switch v-model="typeControl" />
                </div>
                <img :src="getImgUrl('analogo')" class="h-6 w-6 inline-block align-middle"/>
              </div>
        </vx-card>
      </div>
      <div class="w-full sm:w-auto p-1">
        <vx-card class="py-4 pt-6 h-full flex items-center justify-center">
          <div class="sm:hidden">
            <div class="w-full p-2 py-4">
              <div class="text-center">{{$t('Labels.Serie')}}</div>
              <div v-if="response.serie" class="text-center font-bold text-lg">{{response.serie}}</div>
            </div>
            <div class="w-full p-2 py-4">
              <div class="text-center">{{$tc('Labels.TankLevel',0)}}</div>
              <div class="text-center" v-if="response.percent">
                <statusItem custom="justify-center" :status="getStatus(response.percent)" :percent="response.percent"/>
              </div>
            </div>
            <div class="w-full p-2 py-4">
              <div class="text-center">{{$t('Labels.Battery')}}</div>
              <div class="text-center" v-if="response.battery">
                <icon-battery-percent class="align-middle" width="25" height="25" iconColor="#000" :percent="parseFloat(response.battery)" /> <span class="align-middle">{{response.battery}} %</span>
              </div>
            </div>
            <div class="w-full p-2 py-4">
              <div class="text-center">{{$t('Labels.Liters')}}</div>
              <div v-if="response.capacity" class="text-center font-bold text-lg">{{getLiters(response.percent, response.capacity)}} de {{response.capacity}}</div>
            </div>
            <div class="w-full p-2 py-4">
              <div class="text-center">{{$t('Labels.Signal')}}</div>
              <div class="text-center" v-if="response.rssi">
                <icon-signal-percent class="align-middle" width="25" height="25" iconColor="#000" :percent="getSignalPercent(response.rssi)" /> <span class="align-middle">{{getSignalPercent(response.rssi)}}%</span>
              </div>
            </div>
          </div>

          <table class="w-full hidden sm:block" >
            <tr>
              <td class="p-2 py-4" colspan="2">
                <div class="text-center">{{$t('Labels.Serie')}}</div>
                <div v-if="response.serie" class="text-center font-bold text-lg">{{response.serie}}</div>
              </td>
            </tr>
            <tr>
              <td class="p-2 py-4">
                <div class="text-center">{{$tc('Labels.TankLevel',0)}}</div>
                <div class="text-center" v-if="response.percent">
                  <statusItem custom="justify-center" :status="getStatus(response.percent)" :percent="response.percent"/>
                </div>
              </td>
              <td class="p-2 py-4">
                <div class="text-center">{{$t('Labels.Battery')}}</div>
                <div  v-if="response.battery">
                  <icon-battery-percent class="align-middle" width="25" height="25" iconColor="#000" :percent="parseFloat(response.battery)" /> <span class="align-middle">{{response.battery}} %</span>
                </div>
              </td>
            </tr>
            <tr>
            <tr>
              <td class="p-2 py-4">
                <div class="text-center">{{$t('Labels.Liters')}}</div>
                <div v-if="response.capacity" class="text-center font-bold text-lg">{{getLiters(response.percent, response.capacity)}} de {{response.capacity}}</div>
              </td>
              <td class="p-2 py-4">
                <div class="text-center">{{$t('Labels.Signal')}}</div>
                <div v-if="response.rssi">
                  <icon-signal-percent class="align-middle" width="25" height="25" iconColor="#000" :percent="getSignalPercent(response.rssi)" /> <span class="align-middle">{{getSignalPercent(response.rssi)}}%</span>
                </div>
              </td>
            </tr>
          </table>
        </vx-card>
      </div>
      <div class="flex-grow  p-1">
        <vx-card class="pb-2 h-full">
          <div class="sm:hidden">
            <div class="w-full py-2">
              <div class="text-center">{{$t('Labels.ClientNumber')}}</div>
              <div class="text-center font-bold text-lg">{{client_number || '--'}}</div>
            </div>
            <div class="w-full py-2">
              <div class="text-center">{{$t('Labels.ContactNumber')}}</div>
              <div class="text-center font-bold text-lg">{{contact_phone  | VMask('###-###-##-##') || '--'}}</div>
            </div>
            <div class="w-full py-2">
              <div class="text-center">{{$t('Labels.Address')}}</div>
              <div class="text-center font-bold text-lg">{{address || '--'}}</div>
            </div>
            <div class="w-full py-2">
              <div class="text-center">{{$t('Labels.PostalCode')}}</div>
              <div class="text-center font-bold text-lg">{{zip_code || '--'}}</div>
            </div>
            <div class="w-full py-2">
              <div class="map-container m-2" v-if="status_mapa">
                <l-map :center="center" :zoom="zoom" v-if="response" :options="{zoomControl: false }">
                    <l-tile-layer :attribution="attribution" :url="url">
                    </l-tile-layer>
                    <l-marker :lat-lng="marker" ref="position_marker">
                        <l-icon :icon-anchor="staticAnchor">
                            <img :src="require(`@/assets/images/markers/0.svg`)" width="25px;"/>
                        </l-icon>
                    </l-marker>
                </l-map>
              </div>
            </div>
          </div>
          <table class="w-full table-details radius hidden sm:table">
            <thead>
              <th colspan="3">
                {{$t('Labels.DeviceInformation')}}
                <feather-icon v-if="!editClient"  @click="editClient = true" icon="EditIcon" svgClasses="h-5 w-5 text-grey-ligth" class="float-right cursor-pointer hover:text-primary"/>
                <feather-icon v-if="editClient" @click="editClient = false" icon="XIcon" svgClasses="h-5 w-5 text-grey-ligth" class="float-right cursor-pointer hover:text-primary"/>
                <feather-icon v-if="editClient" @click="updateClient()" icon="SaveIcon" svgClasses="h-5 w-5 text-grey-ligth" class="float-right cursor-pointer hover:text-primary"/>    
              </th>
            </thead>
            <tbody>
              <tr>
                <listItem
                  class="px-5"
                  :value="client_number || '--'"
                  :description="$t('Labels.ClientNumber')"
                ></listItem>
                <listItem 
                  class="px-5"
                  v-if="!editClient"
                  :value="contact_phone  | VMask('###-###-##-##') || '--'"
                  :description="$t('Labels.ContactNumber')"
                ></listItem>
                <td v-if="editClient">
                  <vs-input  class="" :label="$t('Labels.ContactNumber')" type="text" v-model="contact_phone"  v-mask="'###-###-##-##'" />         
                </td>
                <td rowspan="5" width="50%">
                  <div v-if="!status_mapa" class="map-container text-center h-full">{{$t('Labels.NoData')}}</div>
                  <div class="map-container m-2" v-if="status_mapa">
                    <l-map :center="center" :zoom="zoom" v-if="response" :options="{zoomControl: false }">
                        <l-tile-layer :attribution="attribution" :url="url">
                        </l-tile-layer>
                        <l-marker :lat-lng="marker" ref="position_marker">
                            <l-icon :icon-anchor="staticAnchor">
                                <img :src="require(`@/assets/images/markers/0.svg`)" width="25px;"/>
                            </l-icon>
                        </l-marker>
                    </l-map>
                  </div>
                </td>
              </tr>
              <tr>
                <listItem
                  v-if="!editClient"
                  colspan="2"
                  class="px-5"
                  :value="address || '--'"
                  :description="$t('Labels.Address')"
                ></listItem>
              </tr>
              <td v-if="editClient">
                  <vs-input  class="" :label="$t('Labels.Address')" type="text" v-model="address" />         
              </td>
              <tr>
                <listItem
                  v-if="!editClient"
                  colspan="2"
                  class="px-5"
                  :value="response.zip_code || '--'"
                  :description="$t('Labels.PostalCode')"
                ></listItem>
              </tr>
              <td v-if="editClient">
                  <vs-input  class="" :label="$t('Labels.PostalCode')" type="text" v-model="zip_code" />         
              </td>
            </tbody>
          </table>
        </vx-card>
      </div>
    </div>
    <div class="vx-row p-1">
      <div class="w-full sm:w-1/2 p-1">
        <vx-card class="p-5">
          <div class="text-center">
            <label>{{$t('Labels.LastChargeGas')}}</label>
            <h4>{{formDate(dateRecharge)}}</h4>
          </div>
          <br>
          <vue-apex-charts v-if="chartConsume" type="line" height="250" :options="consumeChart.chartOptions" :series="consumeChart.series"></vue-apex-charts>
          <vue-apex-charts v-if="chartWeek" type="line" height="250" :options="consumeWeek.chartOptions" :series="consumeWeek.series"></vue-apex-charts>
          <vue-apex-charts v-if="chartRecharge" type="line" height="250" :options="rechargeChart.chartOptions" :series="rechargeChart.series"></vue-apex-charts>
        </vx-card>
      </div>
     <div class="w-full sm:w-1/2 p-1">
        <vx-card class="h-full">
          <table class="w-full table-alerts radius">
            <thead>
              <tr>
                <th colspan="4" class="text-center">
                  <div class="align-middle inline-block uppercase">{{$t('Labels.History')}}</div>
                  <vs-button class="float-right align-middle" color="primary" type="flat" size="small" :to="`/gas/${uuid}/history`">{{$t('Labels.SeeMore')}}</vs-button>
                </th>
              </tr>
              <tr v-show="alerts.length > 0">
                <th>
                  {{$tc('Labels.TankLevel',1)}}
                </th>
                <th>
                  {{$t('Labels.Liters')}}
                </th>
                <th>
                  {{$t('Labels.Date')}}
                </th>
              </tr>
              
            </thead>
            <tbody>
              <tr v-show="alerts.length == 0"><td colspan="3" class="text-center py-2">{{$t('Labels.NoData')}}</td></tr>
              <tr v-for="(item, index) in alerts" :key="index" :class="item.tipo === 'R' ? 'bg-light-info' : ''">
                <td>
                  <statusItem  :status="getStatus(item.percent)" :percent="item.percent"/>  
                </td>
                <td>
                 {{getLiters(item.percent, response.capacity)}} / {{response.capacity}}
                </td>
                <td class="text-center">
                  {{relativeTimeConvert(item.created_at)}}
                  <div v-if="item.tipo === 'R'">
                    <feather-icon
                    icon="ArrowUpCircleIcon"
                    class="p-2"/>
                    <b>{{$t('Labels.LastChargeGas')}}</b>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </vx-card>
      </div>
      <div>
      </div>
    </div>
  </div>
</template>
<script>
import {request} from '@/request.js'
import statusItem from '@/components/statusItem/statusItem.vue'
import listItem from '@/components/listItem/listItem.vue'
import { GChart } from 'vue-google-charts'
import controlDigital from '@/components/controlDigital/controlDigital.vue'
import VueApexCharts from 'vue-apexcharts'
import {
  LMap,
  LTileLayer,
  LMarker,
  LIcon
} from 'vue2-leaflet'
import 'leaflet-fullscreen/dist/leaflet.fullscreen.css'
import 'leaflet-fullscreen/dist/Leaflet.fullscreen'
import 'leaflet/dist/leaflet.css'
import {getStatusByPercent, getSignalPercent, formatDateLanguages} from '@/helpers.js'
import iconBatteryPercent from '@/components/icons/iconBatteryPercent'
import iconSignalPercent from '@/components/icons/iconSignalPercent'
import L from 'leaflet'

export default {
  components: {
    statusItem,
    listItem,
    GChart,
    controlDigital,
    VueApexCharts,
    LMap,
    LTileLayer,
    LMarker,
    LIcon,
    iconBatteryPercent,
    iconSignalPercent
  },
  data () {
    return {
      response: [],
      alerts:[],
      client_uuid: '',
      zip_code: '',
      address: '',
      client_number: '',
      contact_phone: '',
      uuid: this.$route.params.uuid,
      typeControl: false,
      chartOptions: {
        width: 120,
        height: 120,
        redFrom: 90,
        redTo: 100,
        yellowFrom:0,
        yellowTo: 20,
        majorTicks: ['0', '20', '40', '60', '80', '100'],
        max: 100,
        min: 0
      },
      data: [
        ['Label', 'Value'],
        ['GAS', 80]
      ],
      consumeChart: {
        series: [
          {
            name: this.$t('Labels.Current'),
            data: []
          },
          {
            name: this.$t('Labels.Previous'),
            data: []
          }
        ],
        chartOptions: {
          chart: {
            height: 350,
            zoom: {
              enabled: false
            }
          },
          colors: ['#00C3C3', '#2196f3'],
          dataLabels: {
            enabled: false
          },
          stroke: {
            curve: 'straight'
          },
          title: {
            text:  this.$t('Labels.DailySpend'),
            align: 'left'
          },
          grid: {
            row: {
              colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
              opacity: 0.5
            }
          },
          xaxis: {
            categories: []
          }
        }
      },
      consumeWeek: {
        series: [
          {
            name: this.$t('Labels.Current'),
            data: []
          },
          {
            name: this.$t('Labels.Previous'),
            data: []
          }
        ],
        chartOptions: {
          chart: {
            height: 350,
            zoom: {
              enabled: false
            }
          },
          colors: ['#00C3C3', '#2196f3'],
          dataLabels: {
            enabled: false
          },
          stroke: {
            curve: 'straight'
          },
          title: {
            text:  this.$t('Labels.WeeklySpend'),
            align: 'left'
          },
          grid: {
            row: {
              colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
              opacity: 0.5
            }
          },
          xaxis: {
            categories: [
              this.$t('Labels.Sunday'),
              this.$t('Labels.Monday'),
              this.$t('Labels.Tuesday'),
              this.$t('Labels.Wednesday'),
              this.$t('Labels.Thursday'),
              this.$t('Labels.Friday'),
              this.$t('Labels.Saturday')
            ]
          }
        }
      },
      rechargeChart: {
        series: [
          {
            name: 'litros',
            data: []
          }
        ],
        chartOptions: {
          chart: {
            height: 350,
            zoom: {
              enabled: false
            }
          },
          colors: ['#00C3C3'],
          dataLabels: {
            enabled: false
          },
          stroke: {
            curve: 'straight'
          },
          title: {
            text: 'Recargas',
            align: 'left'
          },
          grid: {
            row: {
              colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
              opacity: 0.5
            }
          },
          xaxis: {
            categories: []
          }
        }
      },
      columnChart: {
        series: [
          {
            name: 'Ayer',
            data: [44, 55, 57, 56, 61, 58, 63, 60, 66]
          },
          {
            name: 'Consumo mensual',
            data: [44, 55, 57, 56, 61, 58, 63, 60, 66]
          }
        ],
        chartOptions: {
          colors: '#00C3C3',
          plotOptions: {
            bar: {
              horizontal: false,
              endingShape: 'rounded',
              columnWidth: '55%'
            }
          },
          dataLabels: {
            enabled: false
          },
          stroke: {
            show: true,
            width: 2,
            colors: ['transparent']
          },
          title: {
            text: 'Consumo Mensual',
            align: 'left'
          },
          xaxis: {
            categories: ['Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct']
          },
          yaxis: {
            title: {
              text: 'Kgs'
            }
          },
          fill: {
            opacity: 1

          },
          tooltip: {
            y: {
              formatter (val) {
                return `${  val  } kg`
              }
            }
          }
        }
      },
      donutChart: {
        series: [45, 55],
        chartOptions: {
          colors: ['#00C3C3', '#28C76F'],
          title: {
            text: 'Capacidad tanque para consumos',
            align: 'left'
          },
          responsive: [
            {
              breakpoint: 480,
              options: {
                chart: {
                  width: 300
                },
                legend: {
                  position: 'left',
                  horizontalAlign: 'left'
                }
              }
            }
          ]
        }
      },
      zoom:17,
      center: L.latLng(47.41322, -1.219482),
      url:'https://cartodb-basemaps-{s}.global.ssl.fastly.net/light_all/{z}/{x}/{y}.png',
      attribution:'',
      marker: L.latLng(47.41322, -1.219482),
      staticAnchor: [12, 27],
      icon_marker: [],
      status_mapa: false,
      editDevice: false,
      editClient: false,
      chartConsume: false,
      chartWeek: false,
      chartRecharge: false,
      clientEditor: {},
      deviceEditor: {},
      dateRecharge: []
    }
  },

  methods: {
    formDate (date) {
      return formatDateLanguages(date, 'hour')
    },
    async getResponse () {
      const params = {
        url: `gas_devices/${this.uuid}`,
        method: 'GET'
      }
      await request(params).then(response => {
        this.response = response.data.data
        this.dateRecharge = response.data.lastRecharge[0].created_at
        this.client_uuid = this.response.uuid_client
        this.address = this.response.address
        this.client_number = this.response.client_number
        this.zip_code = this.response.zip_code
        this.contact_phone = this.response.contact_phone
        
        this.deviceEditor.name = this.response.name
        this.data[1][1] = parseFloat(this.response.percent)
        if (this.response.latlong.length > 0) {
          const location = this.response.latlong.split(',')
          this.marker = L.latLng(location[0], location[1])
          this.center = L.latLng(location[0], location[1])
          this.status_mapa = true
        }
        this.alerts = this.response.gas_devices

      }).finally(() => {
        this.$vs.loading.close()
      })
      
    },
    async updateClient () {
      const params = {
        url: `gas_clients/${this.client_uuid}`,
        method: 'PUT',
        params:{
          contact_phone: this.contact_phone.replaceAll('-', '')
        }
      }
      await request(params).then(async () => {
        const params_device = {
          url: `gas_devices/${this.uuid}`,
          method: 'PUT',
          params:{
            address: this.address,
            zip_code: this.zip_code
          }
        }
        await request(params_device).then(() => {
          this.getResponse()
        }).finally(() => {
          this.editDevice = false
        })
      }).finally(() => {
        this.editClient = false
      })  
    },
    async updateDevice () {
      const params = {
        url: `gas_devices/${this.uuid}`,
        method: 'PUT',
        params:{
          name: this.deviceEditor.name
        }
      }
      await request(params).then(() => {
        this.response.name = this.deviceEditor.name
      }).finally(() => {
        this.editDevice = false
      })
    },
    async getConsume () {
      const params = {
        url: `gas_devices/${this.uuid}/consume_by_day`,
        method: 'GET'
      }
      await request(params).then(response => {
        let index = 0
        for (const key in response.data.data) {
          if (Object.hasOwnProperty.call(response.data.data, key)) {
            const element = response.data.data[key]
            if (index < 2) element.forEach(item => {
              this.consumeChart.series[index].data.push(parseFloat(item.consumodia) * -1)
              if (index === 0) this.consumeChart.chartOptions.xaxis.categories.push(item.hours)
            })
          }
          index++
        }
      }).finally(() => {
        this.chartConsume = true
      })
    },
    async getConsumeWeek () {
      const params = {
        url: `gas_devices/${this.uuid}/consume_by_week`,
        method: 'GET'
      }
      await request(params).then(response => {
        let index = 1
        for (const key in response.data.data) {
          if (Object.hasOwnProperty.call(response.data.data, key)) {
            const element = response.data.data[key]    
            element.forEach(item => {
              this.consumeWeek.series[index].data.push(parseFloat(item.consumodia) * -1)
            })
          }
          index--
        }
        
      }).finally(() => {
        this.chartWeek = true
      })
    },
    async getRecharge () {
      const params = {
        url: `gas_devices/${this.uuid}/recharge`,
        method: 'GET'
      }
      await request(params).then(response => {
        response.data.data.forEach(item => {
          this.rechargeChart.series[0].data.push(parseFloat(item.recargadia))
          this.rechargeChart.chartOptions.xaxis.categories.push(item.date)
          //const day = parseInt(item.date.split('-')[2]) - 1
          //this.rechargeChart.series[0].data[day] = parseFloat(item.recargadia)
        })
        this.chartRecharge = true
      })
    },
    getImgUrl (name) {
      const images = require.context('@/assets/images/icons/', false, /\.svg$/)
      return images(`./${  name  }.svg`)
    },
    getStatus (percent) {
      return getStatusByPercent(percent)
    },
    getLiters (percent, capacity) {
      return  (capacity * (percent / 100)).toFixed(2)
    },
    getSignalPercent (value) {
      return getSignalPercent(value)
    },
    relativeTimeConvert (date) {
      return this.$dayjs().to(this.$dayjs(date))
    }
  },
  sockets: {
    gas (payload) {
      if (this.response.deveui === payload.deveui) {
        this.response.rssi = payload.rssi
        this.response.battery = payload.battery
        this.response.percent = payload.percent
        this.response.updated_at = payload.updated_at
      }
    }
  },
  created () {
    this.getResponse()
    this.getConsume()
    this.getConsumeWeek()
  }
}
</script>